import { FC } from "react";
import { Trans } from "@lingui/macro";
import { useTheme } from "@emotion/react";
import { Refresh } from "src/icons";
import { ResetButton, ResetFiltersFooter } from "./ResetFilters.styled";

export interface ResetFiltersProps {
  activeCount: number;
  onClear: () => void;
}

const ResetFilters: FC<ResetFiltersProps> = ({ activeCount, onClear }) => {
  const theme = useTheme();
  const isDisabled = activeCount === 0;
  const iconColor = isDisabled
    ? theme.colors?.tone.silver
    : theme.colors?.tone.black;

  return (
    <ResetFiltersFooter>
      <ResetButton disabled={isDisabled} onClick={onClear}>
        <Refresh width={18} height={17} stroke={iconColor} />
        <span>
          <Trans>Reset</Trans>
        </span>
      </ResetButton>
    </ResetFiltersFooter>
  );
};

export { ResetFilters };
